module.exports = __webpack_public_path__ + "static/img/day7.5a4ae35.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rural/tour1/day7.jpg
// module id = lp0r
// module chunks = 0